import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import LoadingSpinner from "../composant_reutilisable/loading";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';

const Inscription = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        nom: "",
        prenoms: "",
        email: "",
        telephone: "",
        mdp1: "",
        mdp2: "",
    });
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [showPassword1, setShowPassword1] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: name === 'nom' ? value.toUpperCase() : value
        });
    };

    const handlePhoneChange = (value, countryData) => {
        if (value.startsWith("229")) {
            let localNumber = value.slice(3);
            if (!localNumber.startsWith("01")) {
                localNumber = "01" + localNumber.replace(/^0+/, "");
            }
            if (localNumber.length > 10) {
                localNumber = localNumber.slice(0, 10);
            }
            const finalValue = "229" + localNumber;
            setFormData((prev) => ({ ...prev, telephone: finalValue }));
        } else {
            setFormData((prev) => ({ ...prev, telephone: value }));
        }
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 7000);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation du nom
        if (!formData.nom) {
            showAlert("Le champ nom est manquant.", "danger");
            window.scrollTo(0, 0);
            return;
        }
        
        // Validation du prénom
        if (!formData.prenoms) {
            showAlert("Le champ prénom est manquant.", "danger");
            window.scrollTo(0, 0);
            return;
        }

        // Validation de l'email
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const Email = (formData.email || "").trim();
        if (!Email) {
            showAlert("L'adresse email est obligatoire.", 'danger');
            window.scrollTo(0, 0);
            return;
        }
        if (!emailRegex.test(Email)) {
            showAlert("L'email saisi n'est pas valide !", 'danger');
            window.scrollTo(0, 0);
            return;
        }

        // Validation du téléphone
        if (!formData.telephone) {
            showAlert("Le champ téléphone est manquant.", "danger");
            window.scrollTo(0, 0);
            return;
        }

        // Validation des mots de passe
        if (!formData.mdp1) {
            showAlert("Le mot de passe est manquant.", "danger");
            window.scrollTo(0, 0);
            return;
        }
        if (!formData.mdp2) {
            showAlert("La confirmation du mot de passe est manquante.", "danger");
            window.scrollTo(0, 0);
            return;
        }
        if (formData.mdp1 !== formData.mdp2) {
            showAlert("Les mots de passe ne correspondent pas.", "danger");
            window.scrollTo(0, 0);
            return;
        }

        setIsLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/api/web/inscription/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ formData }),
            });

            const data = await response.json();
            console.log("=== RÉPONSE INSCRIPTION ===", data);
            
            setIsLoading(false);

            if (response.ok && data.success) {
                // Stockage des données d'authentification (compatible avec useAuth)
                localStorage.setItem('access_token', data.data.access_token);
                localStorage.setItem('refresh_token', data.data.refresh_token);
                localStorage.setItem('userId', data.data.id);
                
                if (data.data.groupe_id) {
                    localStorage.setItem('groupe_id', data.data.groupe_id);
                }
                
                // Stockage optionnel des infos utilisateur
                localStorage.setItem('user_nom', data.data.nom);
                localStorage.setItem('user_prenoms', data.data.prenoms);
                localStorage.setItem('user_email', data.data.email);
                
                showAlert("Inscription réussie ! Redirection vers le tableau de bord...", "success");
                
                // Redirection après un court délai pour que l'utilisateur voie le message
                setTimeout(() => {
                    navigate("/Dashboard");
                }, 1500);
                
            } else {
                showAlert(data.message || "Erreur lors de l'inscription", "danger");
            }

        } catch (error) {
            setIsLoading(false);
            console.error("Erreur:", error);
            showAlert("Erreur de connexion au serveur. Veuillez réessayer.", "danger");
        }
    };

    return (
        <>
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "100vh", backgroundColor: "#f5f5f5" }}
                >
                    <div className="ibox" style={{ width: "100%", maxWidth: "450px" }}>
                        <div className="ibox-content">
                            <h3 className="m-t-none m-b text-center">Créer un compte</h3>

                            {alert.message && (
                                <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
                                    {alert.message}
                                    <button type="button" className="close" data-dismiss="alert" onClick={() => setAlert({ message: '', type: '' })}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>
                                <div className="form-group row">
                                    <div className="col-sm-4">
                                        <label className="col-form-label" style={{ whiteSpace: "nowrap" }}>
                                            Nom
                                        </label>
                                        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                    </div>
                                    <div className="col-sm-8">
                                        <input
                                            type="text"
                                            name="nom"
                                            placeholder="Saisir le nom"
                                            className="form-control"
                                            value={formData.nom}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-sm-4">
                                        <label className="col-form-label" style={{ whiteSpace: "nowrap" }}>
                                            Prénoms
                                        </label>
                                        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                    </div>
                                    <div className="col-sm-8">
                                        <input
                                            type="text"
                                            name="prenoms"
                                            placeholder="Saisir le prénom"
                                            className="form-control"
                                            value={formData.prenoms}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-sm-4">
                                        <label className="col-form-label" style={{ whiteSpace: "nowrap" }}>
                                            Email
                                        </label>
                                        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                    </div>
                                    <div className="col-sm-8">
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Saisir l'email"
                                            className="form-control"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-sm-4">
                                        <label className="col-form-label" style={{ whiteSpace: "nowrap" }}>
                                            Téléphone
                                        </label>
                                        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                    </div>
                                    <div className="col-sm-8">
                                        <PhoneInput
                                            name="telephone"
                                            value={formData.telephone}
                                            onChange={handlePhoneChange}
                                            required
                                            placeholder="01 XX XX XX XX"
                                            country="bj"
                                            preferredCountries={['bj']}
                                            inputStyle={{
                                                width: "100%",
                                                height: "38px",
                                                fontSize: "14px",
                                                paddingLeft: "55px"
                                            }}
                                            containerStyle={{ width: "100%" }}
                                            inputProps={{
                                                name: "telephone",
                                                required: true,
                                            }}
                                            dropdownStyle={{
                                                maxHeight: "200px",
                                                overflowY: "auto",
                                                zIndex: 1050,
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-sm-4">
                                        <label className="col-form-label" style={{ whiteSpace: "nowrap" }}>
                                            Mot de passe
                                        </label>
                                        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                    </div>
                                    <div className="col-sm-8 position-relative">
                                        <input
                                            type={showPassword1 ? "text" : "password"}
                                            name="mdp1"
                                            placeholder="Saisir le mot de passe"
                                            className="form-control"
                                            value={formData.mdp1}
                                            onChange={handleChange}
                                            required
                                        />
                                        <span
                                            onClick={() => setShowPassword1(!showPassword1)}
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                right: "10px",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                color: "#666",
                                            }}
                                        >
                                            {showPassword1 ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                </div>

                                <div className="form-group row mt-2">
                                    <div className="col-sm-4">
                                        <label className="col-form-label d-inline-flex">
                                            Confirmer
                                            <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                        </label>
                                    </div>
                                    <div className="col-sm-8 position-relative">
                                        <input
                                            type={showPassword2 ? "text" : "password"}
                                            name="mdp2"
                                            placeholder="Retaper le mot de passe"
                                            className="form-control"
                                            value={formData.mdp2}
                                            onChange={handleChange}
                                            required
                                        />
                                        <span
                                            onClick={() => setShowPassword2(!showPassword2)}
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                right: "10px",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                color: "#666",
                                            }}
                                        >
                                            {showPassword2 ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                </div>

                                <div className="text-right mt-3">
                                    <button className="btn btn-sm btn-success" type="submit">
                                        <strong>S'inscrire</strong>
                                    </button>
                                </div>
                            </form>

                            <div className="text-center mt-3">
                                <p>
                                    Déjà un compte ? <Link to="/">Se connecter</Link>
                                </p>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-12 w-100 text-center">
                                <small>
                                    <a href="" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>Show time</a> 
                                    &copy; 2025. Tous droits réservés | Réalisé par 
                                    <a href="https://inovact.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}> INOVACT SARL</a>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Inscription;